export default function reverse(config, notes) {
  notes.reverse();
}